/* global OARC */
( function( $ ) {
	$( document ).ready( function() {
		let $filters = $( '.filter-block__form' );
		let $checkboxGroups = $( '.facet-filters__checkboxes' );
		let $checkboxes = $( '.facet-filters__checkbox' );
		let $offsetInput = $( '.filter-block__offset' );
		let $filterGroups = $( '.facet-filters__group' );
		let $tagslist = $( '.list-tags' );
		let $clearFilters = $( '.list-tags__clear' );
		let $searchSubmit = $( '.search-bar__submit' );
		let $searchBarResults = $( '.search-bar__results' );
		let firstLoad = true;

		let $searchAnchorLinks = $( '.search-filters__anchor-links' );
		let $resultsContainer;

		if ( $( window ).width() < 960 ) {
			$checkboxGroups.collapse( 'hide' );
		}

		// search form
		$searchSubmit.on( 'click', function( e ) {
			let $searchInput = $( '.search-bar__input' );
			let $termInput = $( '.search-filters__term' );

			e.preventDefault();
			$termInput.val( $searchInput.val() ); // changes value of hidden term field in search filters form to search term
			$filters.trigger( 'submit' ); // submits form
		} );

		if ( $checkboxes.length ) {
			// when a checkbox is changed
			$checkboxes.on( 'change', function() {
				let $checkbox = $( this ).find( 'input' );
				let $checkboxID = $checkbox.attr( 'id' );
				let $checkboxTitle = $( this ).find( 'label' ).text();

				if ( $checkboxes.find( 'input' ).is( ':checked' ) ) {
					$clearFilters.removeClass( 'hidden' );
				} else {
					$clearFilters.addClass( 'hidden' );
				}

				if( $checkbox.is( ':checked' ) ) {
					// add a tag to the tag list
					let tag = '<li class="list-tags__tag list-tags__tag--' + $checkboxID + '">' + $checkboxTitle + '<button class="list-tags__close" data-close="'  + $checkboxID + '"></button></li>';
					$tagslist.append( tag );

					// add a click event listener on that tags close button
					$( '.list-tags__close[data-close="' + $checkboxID + '"]' ).one( 'click', function() {
						// uncheck the filter
						$( '#' + $checkboxID ).prop( 'checked', false );
						// remove the tag
						$( this ).parent( '.list-tags__tag' ).remove();
						// if no tags are left hide the clear filters button
						if( $( '.list-tags__tag' ).length === 0 ) {
							$clearFilters.addClass( 'hidden' );
						}
						// changing prop to unchecked doesnt trigger a change event, so we have to tell filters to submit
						$filters.trigger( 'submit' );
					} );
				} else {
					// remove the tag from the tag list
					$( '.list-tags__tag--' + $checkboxID ).remove();
				}

				$filters.trigger( 'submit' );
			} );
		} else {
			$( document ).on( 'change', $filters, function( e ) {

				//TODO: not sure if this is still being used or not
				const $recentGroup = $( '.filter-block__recent-group' );
				if ( $( $recentGroup ).length ) {
					$recentGroup.attr( 'value', e.target.name );
				}

				let $currentFilters = $( e.target );
				let $currentSelects = $currentFilters.closest( 'form' ).find( 'select' );
				let $currentClearSelects = $currentFilters.closest( 'form' ).find( '.filter-block__select-reset' );
				
				if ( $currentSelects.length ) {
					
					let unselected = true;
					
					for ( let step = 0; step < $currentSelects.length; step++ ) {
						let $value = $( $currentSelects[step] ).find( 'option:selected' ).val();
						
						if ( $value !== '' ) {
							unselected = false;
						}
					}
					
					if ( unselected === true ) {
						$currentClearSelects.addClass( 'hidden' );
					} else {
						$currentClearSelects.removeClass( 'hidden' );
					}
				}
				
				$( e.target ).closest( 'form' ).trigger( 'submit' );
			} );
		}

		//reset button on click submit form
		$( document ).on( 'click', '.filter-block__select-reset', function( e ) {
				
			e.preventDefault();
			$( e.target ).closest( 'form' ).trigger( 'reset' ); //resets form
			$( e.target ).addClass( 'hidden' );
			$( e.target ).closest( 'form' ).trigger( 'submit' ); // submits form

		} );


		$clearFilters.find( 'button' ).on( 'click', function() {
			$checkboxes.find( 'input' ).prop( 'checked', false );
			$( '.list-tags__tag' ).remove();
			$clearFilters.addClass( 'hidden' );
			$filters.trigger( 'submit' );
		} );

		$( document ).on( 'submit', '.filter-block__form, .search-bar form', function( event ) {
			event.preventDefault();

			let $form = $( event.target ),
				formData = $form.serialize(),
				endpoint = $form.attr( 'action' ),
				$filterBlock = $form.closest( '.filter-block' ),
				$pagination = $filterBlock.find( '.pagination' ),
				resultsView = $filterBlock.data( 'view' ),
				filterBlockId = $filterBlock.attr( 'id' );

			// set container based on data view
			switch ( resultsView ) {
				case 'grid':
					$resultsContainer = $filterBlock.find( '.case-studies' ).find( '.row' );
					break;
				case 'expert':
					$resultsContainer = $filterBlock.find( '.expert-grid' ).find( '.row' );
					break;
				case 'disaster':
					$resultsContainer = $filterBlock.find( '.card-arrow__wrapper' );
					break;
				case 'list':
				case 'search':
					$resultsContainer = $filterBlock.find( '.resource-items' );
					break;
			}

			$.when( $.ajax( {
				url: endpoint,
				data: formData,
				context: $resultsContainer,
				error: function () {
					$( this ).append( '<li><p>There was an error retrieving this data.</p></li>' );
				}
			} ) ).done( function( responseText ){
				//this code is executed when all ajax calls are done
				var dataString;

				if ( typeof responseText === 'string' ) {
					dataString = responseText;
				} else {
					dataString = JSON.stringify( responseText );
				}

				let data = JSON.parse( dataString ),
					didYouMean = data.didYouMean ? data.didYouMean : false,
					results = data.results,
					totalResults = results.length,
					facets = data.facets,
					pages = data.pagination,
					range = data.resultsRange, // for search bar
					total = data.resultTotal, // for search bar
					term = data.resultTerm; // for search bar

				if ( didYouMean != false ) {
					$( '.search-bar__suggestion' ).remove();
					$( '.search-bar' ).append( '<div class="search-bar__suggestion">' + didYouMean + '</div>' );
				}

				// reset the offset
				$offsetInput.val( '' );

				// wipe out existing results from the results list
				$( this ).empty();

				// update visible checkboxes based on returned facets
				if ( facets != undefined ) {
					$checkboxes.hide();
					$filterGroups.hide();

					for ( let step = 0; step < facets.length; step++ ) {
						$( '#' + facets[step].slug + '-group' ).show();
						let tags = facets[step].tags;

						for ( let step = 0; step < tags.length; step++ ) {
							let currentTag = tags[step].value;
							let currentTagTitle = tags[step].title;
							let currentTagChecked = tags[step].active;

							$( '.' + currentTag ).show();

							if( currentTagChecked ) {
								$( '#' + currentTag ).prop( 'checked', true );

								if( $( '.list-tags__tag--' + currentTag ).length === 0 ) {
									let tag = '<li class="list-tags__tag list-tags__tag--' + currentTag + '">' + currentTagTitle + '<button class="list-tags__close" data-close="'  + currentTag + '"></button></li>';
									$tagslist.append( tag );
									$clearFilters.removeClass( 'hidden' );
								}
							}
						}
					}
				}

				// update search bar based on results
				$searchBarResults.empty();

				// update pagination based on results
				$pagination.empty();

				if( pages.length > 1 ) {
					for ( let step = 0; step < pages.length; step++ ) {
						if ( pages[step].active === true ) {
							$pagination.append( '<li class="page-item active" data-offset="' + pages[step].offset + '"><a class="page-link">' + pages[step].label + '</a></li>' );
						} else if ( pages[step].label === 'Previous' ) {
							$pagination.append( '<li class="page-item active" data-offset="' + pages[step].offset + '"><a class="page-link pagination__prev"  href="#' + filterBlockId + '">' + pages[step].label + '</a></li>' );
						} else if ( pages[step].label === 'Next' ) {
							$pagination.append( '<li class="page-item active" data-offset="' + pages[step].offset + '"><a class="page-link pagination__next"  href="#' + filterBlockId + '">' + pages[step].label + '</a></li>' );
						} else {
							$pagination.append( '<li class="page-item" data-offset="' + pages[step].offset + '"><a class="page-link" href="#' + filterBlockId + '">' + pages[step].label + '</a></li>' );
						}
					}
				}

				// build each result using the returned data and append it to the results list
				if ( resultsView === 'grid' ) {
					for ( let step = 0; step < totalResults; step++ ) {
						let external = '';

						if( results[step].external === true ) {
							external = 'target="_blank" rel="noopener noreferrer"';
						}

						let result = '<div class="col-12 col-md-6 col-lg-4 case-studies__item">';
						result += '<a class="card-arrow" href="' + results[step].url + '" ' + external + '>';
						result += '<h3 class="card-arrow__title">' + results[step].title + '</h3>';
						result += '<p class="card-arrow__description">' + results[step].description + '</p>';
						result += '<div class="card-arrow__arrow"></div></a></div>';

						$( this ).append( result );
					}
				}
				else if ( resultsView === 'list' ) {
					for ( let step = 0; step < totalResults; step++ ) {
						let external = '';

						if( results[step].external === true ) {
							external = 'target="_blank" rel="noopener noreferrer"';
						}

						let result = '<div class="resource-items__card">';
						result += '<a href="' + results[step].url + '" class="resource-items__result" ' + external + '>';
						result += '<div class="resource-items__result-title" >' + results[step].title + '</div>';
						result += '<div class="resource-items__result-description">' + results[step].description + '</div>';
						result += '<div class="btn btn-resource icon-' + results[step].type + '">' + results[step].type + '</div>';
						result += '</a>';
						if ( results[step].languages && results[step].languages.length ) {
							result += '<div class="resource-items__language">';
							result += '<div class="resource-items__language-bottom">';
							result += '<div class="resource-items__language-title">also available in:</div>';
							result += '<div class="resource-items__language-items">';
							for ( let lang = 0; lang < results[step].languages.length; lang++ ) {
								result += '<a class="resource-items__language-item" href="'+ results[step].languages[lang].url +'">'+ results[step].languages[lang].lang +'</a>';
							}
							result += '</div>';
							result += '</div>';
							result += '</div>';
						}
						result += '</div>';

						$( this ).append( result );
					}
				}
				else if ( resultsView === 'expert' ) {
					for ( let step = 0; step < totalResults; step++ ) {

						let result = '<div class="col-12 col-md-6 col-lg-4"><div class="expert-grid__content">';
						result += '<p class="expert-grid__state">' + results[step].state + '</p>';
						result += '<h2>' + results[step].name + '</h2>';
						result += '<p class="expert-grid__title">' + results[step].title + '</p>';
						result += '<p class="expert-grid__email"><a href="mailto:' + results[step].email + '"  target="_blank" rel="noopener noreferrer">' + results[step].email + '</a></p>';
						result += '<p class="expert-grid__website"><a href="' + results[step].website + '" target="_blank" rel="noopener noreferrer">' + results[step].website + '</a></p>';
						result += '<p class="expert-grid__areas"><span>' + results[step].areasText + ':</span> ' + results[step].areas + '</p>';
						result += '</div></div>';

						$( this ).append( result );
					}
				}
				else if ( resultsView === 'disaster' ) {
					for ( let step = 0; step < totalResults; step++ ) {

						let result = '<a class="card-arrow card-arrow--disaster" href="' + results[step].url + '">';
						result += '<p class="card-arrow__date">' + results[step].date + '</p>';
						result += '<h3 class="card-arrow__title">' + results[step].title + '</h3>';
						result += '<p class="card-arrow__description">' + results[step].description + '</p>';
						result += '<div class="card-arrow__arrow"></div></a>';

						$( this ).append( result );
					}
				}
				else if ( resultsView === 'search' ) {
					for ( let step = 0; step < totalResults; step++ ) {

						let external = '';

						if( results[step].external === true ) {
							external = 'target="_blank" rel="noopener noreferrer"';
						}

						let result = '<div class="resource-items__card">';
						result += '<a href="' + results[step].url + '" class="resource-items__result" ' + external + '>';
						result += '<div class="resource-items__result-title" >' + results[step].title + '</div>';
						result += '<div class="resource-items__result-description">' + results[step].description + '</div>';
						result += '<div class="btn btn-resource icon-' + results[step].type + '">' + results[step].type + '</div>';
						result += '</a>';
						if ( results[step].languages && results[step].languages.length ) {
							result += '<div class="resource-items__language">';
							result += '<div class="resource-items__language-bottom">';
							result += '<div class="resource-items__language-title">also available in:</div>';
							result += '<div class="resource-items__language-items">';
							for ( let lang = 0; lang < results[step].languages.length; lang++ ) {
								result += '<a class="resource-items__language-item" href="'+ results[step].languages[lang].url +'">'+ results[step].languages[lang].lang +'</a>';
							}
							result += '</div>';
							result += '</div>';
							result += '</div>';
						}
						result += '</div>';

						$( this ).append( result );
					}
				}

				if( $( '.search-filters__group[data-dynamic="true"]' ).length ) {
					let $dynamicFilterGroups = $( '.search-filters__group[data-dynamic="true"]' );

					$dynamicFilterGroups.each( function() {
						let currentGroupName = $( this ).data( 'name' );
						let $currentRadioGroup = $( this ).find( '.search-filters__radio-group' );
						let currentGroupOptions = data[currentGroupName];

						if ( currentGroupOptions != undefined ) {
							if ( currentGroupOptions.length <= 1 ) {
								$currentRadioGroup.hide();
							} else {
								$currentRadioGroup.show();
							}
						}

						$currentRadioGroup.empty();


						for ( let step = 0; step < currentGroupOptions.length; step++ ) {

							let radioGroup = '<div class="search-filters__radio">';
							if ( currentGroupOptions[step].active ) {
								radioGroup += '<input type="radio" name="' + currentGroupName + '" id="' + currentGroupOptions[step].slug + '" value="' + currentGroupOptions[step].slug + '"  checked=""';
								
								//adds disables attribute to input tag if count is 0 or less
								if ( currentGroupOptions[step].count <= 0 ) {
									radioGroup += ' disabled';
								}
								radioGroup += '>';
								$( '.search-bar__total-results' ).text( currentGroupOptions[step].count );
							} else {
								radioGroup += '<input type="radio" name="' + currentGroupName + '" id="' + currentGroupOptions[step].slug + '" value="' + currentGroupOptions[step].slug + '"';

								//adds disables attribute to input tag if count is 0 or less
								if ( currentGroupOptions[step].count <= 0 ) {
									radioGroup += ' disabled';
								}
								radioGroup += '>';
							}
							radioGroup += '<label for="' + currentGroupOptions[step].slug + '">' + currentGroupOptions[step].type + ' (' + currentGroupOptions[step].count + ')</label>';
							radioGroup += '</div>';

							$currentRadioGroup.append( radioGroup );
						}

						let radioGroup = '<div class="search-filters__radio">';
						if ( $( this ).find( '.search-filters__radio input[checked=""]' ).length ) {
							radioGroup += '<input type="radio" name="' + currentGroupName + '" id="' + currentGroupName + 'All" value="all">';
						} else {
							radioGroup += '<input type="radio" name="' + currentGroupName + '" id="' + currentGroupName + 'All" value="all" checked="">';
						}
						radioGroup += '<label for="' + currentGroupName + 'All">All</label>';
						radioGroup += '</div>';

						$currentRadioGroup.prepend( radioGroup );

					} );
				}

				// empty states
				if ( totalResults === 0 ) {
					// set container based on data view
					switch ( resultsView ) {
						case 'grid':
							$( this ).append( '<div class="col-12 case-studies__no-results"><p>There are no matches for your currently selected filters.</p></div>' ); // message for no grid results
							break;
						case 'expert':
							$( this ).append( '<div class="col-12"><p>There are no matches for your currently selected filters.</p></div>' ); // message for no expert results
							break;
						case 'disaster':
							$( this ).append( '<p class="card-arrow__no-results">There are no matches for your currently selected filters.</p>' ); // message for no disaster results
							break;
						case 'list':
							$( this ).append( '<li><p>There are no matches for your currently selected filters.</p></li>' ); // message for no list results
							break;
						case 'search':
							$( this ).append( '<li><p>Sorry, there are no matches for your search criteria.</p></li>' ).addClass( 'resource-items--no-results' ); // message for no search results & adds class
							$searchAnchorLinks.show(); // shows anchor links
							break;
					}
				} else if ( resultsView === 'search' ) {
					$( this ).removeClass( 'resource-items--no-results' );
					$searchAnchorLinks.hide();
				}

				// Check if search term is empty string
				if ( term != '' ) {
					$( '.search-filters__sidebar' ).removeClass( 'hidden' );

					if ( pages.length ) {
						$searchBarResults.append( 'Showing <span>' + range + '</span> of <span class="search-bar__total-results">' + total + '</span> results for "<span>' + term + '</span>"' );
					}
					else {
						$searchBarResults.append( 'No results for "<span>' + term + '</span>"' );
					}
				}
				else {
					$( '.search-filters__sidebar' ).addClass( 'hidden' );
					$resultsContainer.empty();
					$resultsContainer.append( '<li><p>Use the search bar above to begin your search</p></li>' );
				}

				if( $( '.page-link' ).length ) {
					$( document ).on( 'click', '.page-link', function( e ) {
						const $this = $( e.target ).closest( '.page-item' );
						const $closestForm = $this.closest( '.filter-block' ).find( '.filter-block__form' );
						let selectedPageOffset = $this.data( 'offset' );
						// update the offset input
						$closestForm.find( '.filter-block__offset' ).val( selectedPageOffset );
						// changing prop to unchecked doesnt trigger a change event, so we have to tell filters to submit
						$closestForm.trigger( 'submit' );
					} );
				}

				if( firstLoad === true ) {
					firstLoad = false;
					OARC.init( true, 'bottom-right', 'default', false, 'ladrc-english' );
				}
			} );
		} );

		// submit form on page load
		$filters.trigger( 'submit' );

		//populates main search bar
		var queryString = window.location.search;
		var searchTerm = new URLSearchParams( queryString ).get( 'term' );
		if ( searchTerm ) {
			$( '#search' ).val( searchTerm );
		}
	} );
} )( jQuery );